module.exports = __webpack_public_path__ + "static/media/showfuer_logo.151c7baa.png";